import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import * as styles from "./movies.module.css";
import Alone from "../Assets/svg/couple-users.svg";
import Many from "../Assets/svg/five-users.svg";
import Header from "../components/header";
import { movieDate } from "../utils/date";
import YesBank from "../Assets/yes-bank.png";
import Gmeet from "../Assets/gmeet.png";
import TwoSeven from "../Assets/two-seven.png";
import { Fragment } from "react";

const logo = {
  alone: Alone,
  many: Many,
};

const Movie = props => {
  const [isHover, setIsHover] = useState(false);

  const toggleHover = () => {
    setIsHover(prevState => !prevState);
  };

  return (
    <div
      className={styles.card}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
    >
      <div style={{ position: "relative" }}>
        <div className={styles.date}>{movieDate(props.data.date)}</div>
        <img src={logo[props.data.withwhom]} className={styles.userImage}></img>
      </div>

      <div className={styles.imageContainer}>
        <img
          src={props.data.image}
          className={`${styles.movieImage} ${
            isHover ? styles.movieImageHover : ""
          }`}
        ></img>
      </div>
      <div className={`${styles.extraDetails} ${isHover ? styles.show : ""}`}>
        <p>
          <mark>{props.data.name}</mark>
        </p>
        <p>
          <mark>{props.data.genre}</mark>
        </p>
        <p>
          <mark>{props.data.location}</mark>
        </p>
      </div>
    </div>
  );
};

export default function Movies({ data }) {
  const [type, setType] = useState(0);

  const getComponent = type => {
    switch (type) {
      case 0:
        return (
          <div style={{ width: "100%" }}>
            <div className={styles.banner}>
              <h1 style={{ fontSize: "3em", marginRight: "20px" }}>
                Theatre Movies
              </h1>
              <div
                style={{
                  borderLeft: "4px solid black",
                  padding: "0 20px",
                }}
              >
                <p style={{ fontSize: "2.5em" }}>
                  <strong>Powered</strong> by
                </p>
                <img style={{ width: "330px" }} src={YesBank}></img>
              </div>
            </div>
            <div className={styles.cardOuter}>
              {data.allMarkdownRemark.edges
                .filter(value => value.node.frontmatter.where === "theatre")
                .map(value => (
                  <Movie data={value.node.frontmatter} />
                ))}
            </div>
          </div>
        );
      case 1:
        return (
          <div style={{ width: "100%" }}>
            <div className={styles.banner}>
              <h1 style={{ fontSize: "3em", marginRight: "20px" }}>
                Online Movies
              </h1>
              <div
                style={{
                  borderLeft: "4px solid black",
                  padding: "0 20px",
                }}
              >
                <p style={{ fontSize: "2.5em" }}>
                  <strong>Powered</strong> by
                </p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img style={{ height: "150px" }} src={TwoSeven}></img>
                  <h2 style={{ color: "#009688", marginLeft: "10px" }}>
                    TWO SEVEN
                  </h2>
                </div>
              </div>
              <div
                style={{
                  borderLeft: "4px solid black",
                  padding: "0 20px",
                }}
              >
                <p style={{ fontSize: "2.5em" }}>
                  <strong>Co-Powered</strong> by
                </p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img style={{ width: "500px" }} src={Gmeet}></img>
                </div>
              </div>
            </div>
            <div className={styles.cardOuter}>
              {data.allMarkdownRemark.edges
                .filter(value => value.node.frontmatter.where === "twoseven")
                .map(value => (
                  <Movie data={value.node.frontmatter} />
                ))}
            </div>
          </div>
        );
      case 2:
        return (
          <div style={{ width: "100%" }}>
            <div className={styles.banner}>
              <h1 style={{ fontSize: "3em", marginRight: "20px" }}>
                Home Movies
              </h1>
              <div
                style={{
                  borderLeft: "4px solid black",
                  padding: "0 20px",
                }}
              >
                <p style={{ fontSize: "2.5em" }}>
                  <strong>Powered</strong> by
                </p>
                <h1 style={{ color: "#E50914", fontSize: "2.5em" }}>NETFLIX</h1>
              </div>
            </div>
            <div className={styles.cardOuter}>
              {data.allMarkdownRemark.edges
                .filter(value => value.node.frontmatter.where === "physical")
                .map(value => (
                  <Movie data={value.node.frontmatter} />
                ))}
            </div>
          </div>
        );
    }
  };

  return (
    <div className={styles.outer}>
      {/* <Header headerText="Movies" /> */}
      <div>
        <button
          className={`${styles.button} ${
            type === 0 ? styles.buttonActive : ""
          }`}
          onClick={() => setType(0)}
        >
          Theatre Movies
        </button>
        <button
          className={`${styles.button} ${
            type === 1 ? styles.buttonActive : ""
          }`}
          onClick={() => setType(1)}
        >
          Online Movies
        </button>
        <button
          className={`${styles.button} ${
            type === 2 ? styles.buttonActive : ""
          }`}
          onClick={() => setType(2)}
        >
          Home Movies
        </button>
      </div>
      {getComponent(type)}
    </div>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//movies//" } }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            name
            where
            genre
            image
            date
            location
            withwhom
          }
          excerpt
        }
      }
    }
  }
`;
